"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _Link = _interopRequireDefault(require("../../atoms/Link"));

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var SiteMap = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SiteMap, _React$Component);

  var _super = _createSuper(SiteMap);

  function SiteMap() {
    (0, _classCallCheck2["default"])(this, SiteMap);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SiteMap, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          links = _this$props.links,
          horizontal = _this$props.horizontal,
          bulleted = _this$props.bulleted;
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List, {
        horizontal: horizontal,
        bulleted: bulleted
      }, links.map(function (_ref, index) {
        var title = _ref.title,
            pageType = _ref.pageType,
            slug = _ref.slug,
            url = _ref.url,
            contentProps = _ref.contentProps;
        return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Item, {
          key: title
        }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Content, null, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
          to: pageType === 'External' ? url : slug,
          linkAs: "span",
          title: title,
          internal: pageType !== 'External',
          contentProps: contentProps
        })));
      }));
    }
  }]);
  return SiteMap;
}(_react["default"].Component);

exports["default"] = SiteMap;
SiteMap.propTypes = {
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    pageTitle: _propTypes["default"].string.isRequired,
    slug: _propTypes["default"].string.isRequired,
    internal: _propTypes["default"].bool,
    className: _propTypes["default"].string
  })).isRequired,
  bulleted: _propTypes["default"].bool,
  horizontal: _propTypes["default"].bool
};
SiteMap.defaultProps = {
  bulleted: false,
  internalLinkComponent: null,
  horizontal: false
};